module.exports = __webpack_public_path__ + "media/images/static/top/urban/center_mobile-eb4ebd0b34194fb80255508ced734661.png";